(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;
  var isMobile = function () { return window.matchMedia('(max-width: 749px)').matches; };
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var panel = drawer.querySelector('.kbcd__panel');
  var itemsEl = drawer.querySelector('[data-cd-items]');
  var emptyEl = drawer.querySelector('[data-cd-empty]');
  var footEl = drawer.querySelector('[data-cd-foot]');
  var progEl = drawer.querySelector('[data-cd-progress]');
  var barEl = drawer.querySelector('[data-cd-bar]');
  var shipEl = drawer.querySelector('[data-cd-ship]');
  var giftEl = drawer.querySelector('[data-cd-gift]');
  var subEl = drawer.querySelector('[data-cd-subtotal]');
  var countEl = drawer.querySelector('[data-cd-count]');
  var upsellEl = drawer.querySelector('[data-cd-upsell]');
  var fsThreshold = parseInt(drawer.getAttribute('data-fs-threshold'), 10) || 0;
  var trap = window.kbTrap ? window.kbTrap(panel, null) : null;
  var lastFocus = null;
  var busy = false;

  function money(cents) {
    try { return '€' + (cents / 100).toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    catch (e) { return '€' + (cents / 100).toFixed(2).replace('.', ','); }
  }
  function post(url, body) {
    return fetch(root + url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) }).then(function (r) { return r.json(); });
  }
  function getCart() { return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }

  var GIFT_ID = (window.kbGwp && window.kbGwp.config) ? window.kbGwp.config.giftId : null;

  function updateCounters(count) {
    document.querySelectorAll('.site-header__cart-count, .header-drawer__cart-count').forEach(function (el) { el.textContent = count; });
  }

  function esc(s) { return (s == null ? '' : String(s)).replace(/[&<>"]/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]; }); }

  function render(cart) {
    if (!cart) return;
    var count = cart.item_count;
    countEl.textContent = count ? '(' + count + ')' : '';
    updateCounters(count);

    if (!cart.items || cart.items.length === 0) {
      itemsEl.innerHTML = '';
      emptyEl.hidden = false; footEl.hidden = true; progEl.hidden = true;
      if (upsellEl) upsellEl.hidden = true;
      return;
    }
    emptyEl.hidden = true; footEl.hidden = false;

    var html = '';
    cart.items.forEach(function (it) {
      var isGift = GIFT_ID && it.variant_id === GIFT_ID;
      var img = it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') + '" alt="" loading="lazy">' : '';
      var props = '';
      if (it.properties) {
        Object.keys(it.properties).forEach(function (k) {
          if (k.charAt(0) === '_' || !it.properties[k]) return;
          props += '<span>' + esc(k) + ': ' + esc(it.properties[k]) + '</span>';
        });
      }
      var priceHtml = isGift ? '<span class="kbcd__item-price kbcd__item-price--free">Gratis</span>' : '<span class="kbcd__item-price">' + money(it.final_line_price) + '</span>';
      var controls = isGift
        ? '<span class="kbcd__item-gifttag">🎁 Cadeau</span>'
        : '<div class="kbcd__qty"><button type="button" data-cd-dec="' + esc(it.key) + '" aria-label="Minder">−</button><span>' + it.quantity + '</span><button type="button" data-cd-inc="' + esc(it.key) + '" aria-label="Meer">+</button></div>'
          + '<button type="button" class="kbcd__item-remove" data-cd-remove="' + esc(it.key) + '">Verwijderen</button>';
      html += '<li class="kbcd__item" data-key="' + esc(it.key) + '">'
        + '<span class="kbcd__item-media">' + img + '</span>'
        + '<div class="kbcd__item-main"><div class="kbcd__item-title">' + esc(it.product_title) + '</div>'
        + (it.variant_title && it.variant_title !== 'Default Title' ? '<div class="kbcd__item-variant">' + esc(it.variant_title) + '</div>' : '')
        + (props ? '<div class="kbcd__item-props">' + props + '</div>' : '') + '</div>'
        + '<div class="kbcd__item-side">' + priceHtml + controls + '</div>'
        + '</li>';
    });
    itemsEl.innerHTML = html;

    // Progress (gratis verzending)
    if (fsThreshold > 0) {
      progEl.hidden = false;
      var qualifying = (window.kbGwp ? window.kbGwp.status(cart).qualifying : cart.total_price);
      var pct = Math.min(100, Math.round((qualifying / fsThreshold) * 100));
      barEl.style.width = pct + '%';
      if (qualifying >= fsThreshold) { shipEl.textContent = 'Yes! Je bestelling wordt gratis verzonden 🚚'; }
      else { shipEl.textContent = 'Nog ' + money(fsThreshold - qualifying) + ' tot gratis verzending'; }
      // GWP-status (drempel uit kbGwp)
      if (window.kbGwp && window.kbGwp.config) {
        var st = window.kbGwp.status(cart);
        giftEl.textContent = st.qualifying >= st.threshold ? 'Je gratis verrassing is verdiend 🎁' : ('Nog ' + money(st.remaining) + ' tot je gratis verrassing 🎁');
      } else { giftEl.textContent = ''; }
    } else { progEl.hidden = true; }

    subEl.textContent = money(cart.total_price);
    renderUpsell(cart);
  }

  function renderUpsell(cart) {
    if (!upsellEl) return;
    var inCart = {};
    cart.items.forEach(function (it) { inCart[it.variant_id] = true; });
    var shown = 0;
    upsellEl.querySelectorAll('[data-cd-up]').forEach(function (up) {
      var vid = parseInt(up.getAttribute('data-variant-id'), 10);
      var hide = inCart[vid] || shown >= 2 || (GIFT_ID && vid === GIFT_ID);
      up.style.display = hide ? 'none' : '';
      if (!hide) shown++;
    });
    upsellEl.hidden = shown === 0;
  }

  function refresh() { return getCart().then(render); }

  function open() {
    if (!isMobile()) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    if (trap) trap.on(); else panel.focus();
    refresh();
  }
  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (trap) trap.off();
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  // Sync na mutatie: GWP + render (één bron)
  function syncAndRender() {
    return (window.kbGwp ? window.kbGwp.sync() : getCart()).then(render);
  }

  // Close-triggers
  drawer.querySelectorAll('[data-cart-close]').forEach(function (el) { el.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });

  // Header-cart → drawer (alleen mobiel; desktop = normale navigatie)
  document.querySelectorAll('a[href$="/cart"], a[href*="/cart?"], .site-header__cart-pill').forEach(function (link) {
    link.addEventListener('click', function (e) {
      if (!isMobile()) return;
      // laat "Bekijk winkelwagen" in de drawer zelf gewoon navigeren
      if (link.closest('[data-cart-drawer]')) return;
      e.preventDefault();
      // Komt de klik uit de open nav-drawer? Sluit die eerst volledig (aria-hidden, focus-trap
      // vrij, scroll-lock vrij) en open de cart-drawer pas daarna. Nooit twee aria-modal dialogs
      // of twee scroll-locks tegelijk.
      var navDrawer = document.getElementById('header-drawer');
      if (navDrawer && link.closest('#header-drawer') && navDrawer.getAttribute('aria-hidden') === 'false') {
        var navClose = navDrawer.querySelector('[data-drawer-close]');
        if (navClose) { navClose.click(); }
        setTimeout(open, 60); // korte tel zodat nav-drawer trap/scroll-lock echt is vrijgegeven
      } else {
        open();
      }
    });
  });

  // Hoofdproduct add-to-cart (#pdp-form) → toevoegen + GWP-sync + drawer openen (mobiel)
  var pdpForm = document.getElementById('pdp-form');
  if (pdpForm) {
    pdpForm.addEventListener('submit', function (e) {
      if (!isMobile() || !window.fetch) return; // desktop / geen fetch: normale submit → /cart
      e.preventDefault();
      if (busy) return; busy = true;
      var fd = new FormData(pdpForm);
      fetch(root + 'cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
        .then(function () { return syncAndRender(); })
        .then(function () { busy = false; open(); })
        .catch(function () { busy = false; pdpForm.submit(); });
    });
  }

  // Upsell quick-add in drawer → drawer blijft open
  drawer.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-cd-up-add]');
    if (addBtn) {
      if (busy) return; busy = true;
      var vid = addBtn.getAttribute('data-cd-up-add');
      post('cart/add.js', { items: [{ id: vid, quantity: 1 }] })
        .then(function () { addBtn.classList.add('is-added'); setTimeout(function () { addBtn.classList.remove('is-added'); }, 1400); return syncAndRender(); })
        .then(function () { busy = false; }).catch(function () { busy = false; });
      return;
    }
    var dec = e.target.closest('[data-cd-dec]'), inc = e.target.closest('[data-cd-inc]'), rem = e.target.closest('[data-cd-remove]');
    var key = dec ? dec.getAttribute('data-cd-dec') : inc ? inc.getAttribute('data-cd-inc') : rem ? rem.getAttribute('data-cd-remove') : null;
    if (!key) return;
    if (busy) return; busy = true;
    var li = drawer.querySelector('.kbcd__item[data-key="' + key + '"]');
    if (li) li.classList.add('is-busy');
    getCart().then(function (cart) {
      var line = null;
      cart.items.forEach(function (it) { if (it.key === key) line = it; });
      if (!line) { busy = false; return; }
      var q = rem ? 0 : (inc ? line.quantity + 1 : Math.max(0, line.quantity - 1));
      return post('cart/change.js', { id: key, quantity: q }).then(function () { return syncAndRender(); }).then(function () { busy = false; });
    }).catch(function () { busy = false; });
  });

  // Externe cart-updates (bv. PDP cadeau-extra quick-add) → drawer + tellers bijwerken zonder te openen
  document.addEventListener('kb:cart:updated', function (e) {
    if (e.detail && e.detail.cart) { render(e.detail.cart); } else { refresh(); }
  });

  window.kbCartDrawer = { open: open, close: close, refresh: refresh };
}());
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gwp-sync"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.kbGwp) return;
  var cfgEl = document.querySelector('[data-kb-gwp-config]');
  var cfg = cfgEl ? { giftId: parseInt(cfgEl.getAttribute('data-gift-id'), 10), threshold: parseInt(cfgEl.getAttribute('data-threshold'), 10) } : null;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function post(url, body) {
    return fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  function getCart() {
    return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  var api = {
    config: cfg,
    running: false,

    /* Qualifying = totaal exclusief het gift-item zelf. */
    status: function (cart) {
      var giftLine = null, qualifying = 0;
      (cart && cart.items || []).forEach(function (i) {
        if (cfg && i.variant_id === cfg.giftId) { giftLine = i; } else { qualifying += i.final_line_price; }
      });
      var threshold = cfg ? cfg.threshold : 0;
      return { enabled: !!(cfg && cfg.giftId), qualifying: qualifying, threshold: threshold, hasGift: !!giftLine, remaining: Math.max(0, threshold - qualifying) };
    },

    /* Idempotente sync: hoogstens ÉÉN mutatie per call; lock voorkomt dubbele adds bij races.
       Retourneert de verse cart en dispatcht 'kb:cart:updated'. Geen prijsmanipulatie (BXGY doet €0). */
    sync: function () {
      if (!cfg || !cfg.giftId || api.running) { return getCart(); }
      api.running = true;
      return getCart().then(function (cart) {
        var st = api.status(cart);
        var needsAdd = st.qualifying >= cfg.threshold && !st.hasGift;
        var needsRemove = st.hasGift && st.qualifying < cfg.threshold;
        var giftLine = null;
        cart.items.forEach(function (i) { if (i.variant_id === cfg.giftId) giftLine = i; });
        var needsFix = giftLine && st.qualifying >= cfg.threshold && giftLine.quantity > 1;

        if (!needsAdd && !needsRemove && !needsFix) { api.running = false; return cart; }

        var req = needsAdd
          ? post('cart/add.js', { items: [{ id: cfg.giftId, quantity: 1 }] })
          : post('cart/change.js', { id: String(cfg.giftId), quantity: (st.qualifying >= cfg.threshold ? 1 : 0) });

        /* Na de ene mutatie klopt de drempelstatus per definitie → geen her-controle (geen loop). */
        return req.then(function () { return getCart(); }).then(function (fresh) {
          api.running = false;
          return fresh;
        });
      }).then(function (cart) {
        try { document.dispatchEvent(new CustomEvent('kb:cart:updated', { detail: { cart: cart } })); } catch (e) {}
        return cart;
      }).catch(function () { api.running = false; return getCart(); });
    }
  };

  window.kbGwp = api;
}());
  } catch(e) { console.error(e); }
})();

})();
